import { apiUrl } from "../constans";
import apiClient from '../libs/axios';

// Ver docs de backend: negocios-plataforma-contrato-api.md
const API_BASE = `${apiUrl}/v2/negocios/plataforma`;

const unwrap = (response) => response.data?.data ?? response.data;

const negociosPlataforma = {
    namespaced: true,
    state: {
        resumen: null,
        inmobiliarias: [],
        negocios: {
            data: [],
            current_page: 1,
            per_page: 25,
            last_page: 1,
            total: 0,
        },
    },

    mutations: {
        setResumen(state, resumen) {
            state.resumen = resumen;
        },

        setInmobiliarias(state, inmobiliarias) {
            state.inmobiliarias = inmobiliarias;
        },

        setNegocios(state, paginador) {
            const stat = state.negocios;
            stat.data = paginador.data || [];
            stat.current_page = paginador.current_page || 1;
            stat.per_page = paginador.per_page || 25;
            stat.last_page = paginador.last_page || 1;
            stat.total = paginador.total || 0;
        },

        setCurrentPage(state, page) {
            state.negocios.current_page = page;
        },
    },

    actions: {
        async getResumenAction({ commit }, filters = {}) {
            const response = await apiClient.get(`${API_BASE}/resumen`, { params: filters });
            const resumen = unwrap(response) || null;
            commit('setResumen', resumen);
            return resumen;
        },

        // [{ id, nombre, email, negocios }] para el filtro
        async getInmobiliariasAction({ commit }) {
            const response = await apiClient.get(`${API_BASE}/inmobiliarias`);
            const inmobiliarias = unwrap(response) || [];
            commit('setInmobiliarias', inmobiliarias);
            return inmobiliarias;
        },

        async getNegociosAction({ commit }, { filters = {}, page = 1 } = {}) {
            const response = await apiClient.get(`${API_BASE}/negocios`, { params: { page, ...filters } });
            const paginador = unwrap(response) || {};
            commit('setNegocios', paginador);
            return paginador;
        },

        async getNegocioAction(_, id) {
            const response = await apiClient.get(`${API_BASE}/negocios/${id}`);
            return unwrap(response);
        },

        // { url, expira_en_minutos, nombre }. El enlace vence a los 5 minutos
        async getDescargaDocumentoAction(_, { negocioId, documentoId }) {
            const response = await apiClient.get(`${API_BASE}/negocios/${negocioId}/documentos/${documentoId}/descargar`);
            return unwrap(response);
        },
    },
};

export default negociosPlataforma;
